import React, { useState } from "react";
import { setPassword as apiSetPassword, errMsg } from "../../services/accountApi";
import { authCss, S, Brand, PasswordField, MIN_LEN } from "./authUi";

const clearHash = () => {
  try { window.history.replaceState(null, "", window.location.pathname + window.location.search); }
  catch (e) { window.location.hash = ""; }
};

function Row({ ok, text }) {
  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, color: ok ? "var(--success)" : "var(--text-muted)", transition: "color .12s" }}>
      <span aria-hidden="true" style={{ width: 12, textAlign: "center", fontWeight: 700 }}>{ok ? "✓" : "○"}</span>{text}
    </div>
  );
}

export default function SetPasswordPage({ token, onSignedIn, onBack }) {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [remember, setRemember] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [linkDead, setLinkDead] = useState(false);

  const longEnough = pw.length >= MIN_LEN;
  const matches = pw.length > 0 && pw === pw2;
  const valid = longEnough && matches;

  const back = () => { clearHash(); onBack && onBack(); };

  const submit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (busy || !valid) return;
    setBusy(true); setError("");
    try {
      const { user } = await apiSetPassword(token, pw, remember);
      clearHash();
      onSignedIn && onSignedIn(user);
    } catch (err) {
      const st = err && err.response && err.response.status;
      const d = err && err.response && err.response.data && err.response.data.detail;
      if ((st === 400 || st === 404 || st === 410) && !(d && /password/i.test(d) && !/link|token|expired|used/i.test(d))) setLinkDead(true);
      else setError(errMsg(err));
    } finally { setBusy(false); }
  };

  if (linkDead || !token) {
    return (
      <div className="auth-wrap">
        <style>{authCss}</style>
        <div className="auth-card">
          <Brand heading="Link expired" />
          <div style={{ fontSize: 13, color: "var(--text)", lineHeight: 1.45, marginBottom: 14 }}>
            This link has expired or was already used.
          </div>
          <button type="button" className="auth-btn" onClick={back}>Back to sign in</button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-wrap">
      <style>{authCss}</style>
      <form className="auth-card" onSubmit={submit} noValidate>
        <Brand heading="Set your password" />
        <PasswordField id="sp-pw" label="New password" value={pw} onChange={(v) => { setPw(v); setError(""); }}
          autoComplete="new-password" autoFocus disabled={busy} />
        <PasswordField id="sp-pw2" label="Confirm password" value={pw2} onChange={(v) => { setPw2(v); setError(""); }}
          autoComplete="new-password" disabled={busy} />
        <div style={{ display: "grid", gap: 4, margin: "2px 0 12px" }}>
          <Row ok={longEnough} text={`At least ${MIN_LEN} characters`} />
          <Row ok={matches} text="Passwords match" />
        </div>
        <label style={S.check}>
          <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)}
            style={{ width: 15, height: 15, accentColor: "var(--accent)", cursor: "pointer", margin: 0 }} />
          Remember me on this device
        </label>
        {error && <div role="alert" style={S.err}>{error}</div>}
        <button type="submit" className="auth-btn" disabled={busy || !valid}>{busy ? "Saving…" : "Set password and sign in"}</button>
      </form>
    </div>
  );
}
